export const PATH_APP = {
  root: '/',
  connect: (tenant) => `/${tenant}/connect`,
  type: (tenant) => `/${tenant}/type`,
  offices: (tenant) => `/${tenant}/offices`,
  space: (tenant) => `/${tenant}/space`,
};
